module.exports = __webpack_public_path__ + "img/teaser_240x200_richykoch.c7e21c4c.jpg";